<template>
  <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover class="tw-bg-[#1C1C1C] tw-rounded-md">
    <v-carousel-item :src="require('@/assets/images/BLASTSlamII.jpg')" @click="gotoEsports('dota2_matches')">
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/DreamleagueS25.jpg')" @click="gotoEsports('dota2_matches')">
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/PGLWallachiaS3.jpg')" @click="gotoEsports('dota2_matches')">
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/ESLOneRaleigh.jpg')" @click="gotoEsports('dota2_matches')">
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/Casino Roulette.jpg')"
      @click="$router.push({ path: `/live-casino` })"
    >
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/5Games.jpg')"
      @click="$router.push({ path: `/slots?providers=Jili` })"
    >
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/5-Games.jpg')"
      @click="$router.push({ path: `/live-casino?providers=Evolution%20Asia` })"
    >
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/Slots.jpg')" @click="$router.push({ path: `/games` })">
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/LightningRoulette.jpg')"
      @click="$router.push({ path: `/live-casino?q=Lightning%20Roulette` })"
    >
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/Blackjack.jpg')"
      @click="$router.push({ path: `/live-casino?q=blackjack` })"
    >
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  methods: {
    gotoEsports(queryLink) {
      let query = queryLink ? "?t=" + queryLink : "";
      const url =
        process.env.VUE_APP_SERVER_ENV == "prod"
          ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
          : "http://localhost:8000";
      window.open(url + query);
    },
  },
};
</script>
